import styles from "../add.module.css";
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import { isValidPhoneNumber } from "react-phone-number-input";
import Input from "react-phone-number-input/input";
import { usePlacesWidget } from "react-google-autocomplete";
import { useState, useEffect, forwardRef } from "react";
import MapComponent from "../../../../fontend/components/Map";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { authData } from "../../../../admin/components/GetAuth";

const CustomInput = forwardRef((props, ref) => (<TextField {...props} inputRef={ref} id="outlined-basic" label="Phone*" variant="outlined" />));

function Step3({ saveStep3Data, backToTab, bookingData, selectCountry }) {
  const auth = authData();
  const [userAddressList, setUserAddressList] = useState([]);
  const [mapCenter, setMapCenter] = useState({ lat: 5.614818, lng: -0.205874 });
  const [isMarker, setIsMarker] = useState(false);
  const [zoom, setZoom] = useState(12);
  const [defaultCustomer, setDefaultCustomer] = useState("");

  const { register, handleSubmit, control, formState: { errors }, clearErrors, setValue } = useForm({
    mode: "onChange",
    defaultValues: {
      customer_id: "",
      name: "",
      email: "",
      phone: "",
      address: ""
    },
  });

  const { ref: placeRef1 } = usePlacesWidget({
    apiKey: process.env.REACT_APP_MAP_API_KEY,
    onPlaceSelected: (place) => {
      setValue("address", place.formatted_address);
      setValue("latitude", place.geometry.location.lat());
      setValue("longitude", place.geometry.location.lng());

      setMapCenter({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() });
      setIsMarker(true);
      setZoom(18);
    },
    options: {
      types: ["address"],
      componentRestrictions: { country: selectCountry }
    },
  });

  useEffect(() => {
    if (auth?.customer?.id) {
      axios.get(process.env.REACT_APP_API_URL + "v1/customer/adresses/recipient", {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`,
        }
      }).then((response) => {
        if (response.data.status === "SUCCESS") {
          setUserAddressList([{ value: -1, name: "New record" }].concat(response.data.data));

          if (response.data.data.length > 0) {
            setValue("customer_id", response.data.data[0].value);
            setDefaultCustomer(response.data.data[0].value);
          } else {
            setValue("customer_id", -1);
            setDefaultCustomer(-1);
          }
        }
      });
    }
  }, [auth?.api_token, auth?.customer?.id, bookingData?.pickUpData, setValue]);

  useEffect(() => {
    setValue("customer_id", bookingData?.pickUpData?.customer_id);
    setValue("name", bookingData?.pickUpData?.name);
    setValue("email", bookingData?.pickUpData?.email);
    setValue("phone", bookingData?.pickUpData?.phone);
    setValue("address", bookingData?.pickUpData?.address);

    if (bookingData?.pickUpData?.latitude && bookingData?.pickUpData?.longitude) {
      setValue("latitude", bookingData?.pickUpData?.latitude);
      setValue("longitude", bookingData?.pickUpData?.longitude);
      setMapCenter({ lat: parseFloat(bookingData?.pickUpData?.latitude), lng: parseFloat(bookingData?.pickUpData?.longitude) });
      setIsMarker(true);
      setZoom(18);
    }
  }, [bookingData, setValue]);

  useEffect(() => {
    if (defaultCustomer === -1) {
      setValue(`name`, "");
      setValue(`email`, "");
      setValue(`phone`, "");
      setValue(`address`, "");
      setIsMarker(false);
      setZoom(18);
    } else {
      let addressObj = userAddressList.filter((i) => i?.value === defaultCustomer);
      if (addressObj.length > 0) {
        addressObj = addressObj[0];

        setValue("name", addressObj?.name);
        setValue("email", addressObj?.email);
        setValue("phone", addressObj?.phone);
        setValue("address", addressObj?.address);

        if (addressObj?.latitude && addressObj?.longitude) {
          setValue(`latitude`, parseFloat(addressObj?.latitude));
          setValue(`longitude`, parseFloat(addressObj?.longitude));
          setMapCenter({ lat: parseFloat(addressObj?.latitude), lng: parseFloat(addressObj?.longitude) });
          setIsMarker(true);
          setZoom(18);
        }

        clearErrors();
      }
    }
  }, [defaultCustomer, userAddressList, clearErrors, setValue]);

  const onSubmit = (data) => {
    document.documentElement.scrollTo({ top: 0, left: 0, behavior: "instant" });
    saveStep3Data(data);
  }

  return (<>
    <div className={`${styles.StepOneForm}`}>
      <form id="step2-form" onSubmit={handleSubmit(onSubmit)}>
        <div className={`${styles.StepOneFormRow}`}>
          <div className={`${styles.StepOneFormBig}`}>
            <div>
              <div className={`FormFullGroup`}>
                <FormControl fullWidth>
                  <InputLabel>Select or add record*</InputLabel>
                  <Controller
                    control={control}
                    {...register("customer_id")}
                    render={({ field }) => (<Select
                      label="Select or add record*"
                      {...field}
                      onChange={(e) => {
                        field.onChange(e);
                        setDefaultCustomer(e.target.value);
                      }}
                    >
                      {userAddressList?.map((val) => {
                        return (<MenuItem key={val?.value} value={val?.value}>{val?.name}, {val?.address}</MenuItem>);
                      })}
                    </Select>)}
                  />
                </FormControl>
              </div>
            </div>

            <div>
              <div className={`FormFullGroup`}>
                <Controller
                  control={control}
                  {...register("name", { required: "This field is Required" })}
                  render={({ field }) => (<TextField {...field} label="Name*" variant="outlined" />)}
                />
                {errors.name && (<span className={`ErrorM`}>{errors?.name?.message}</span>)}
              </div>
            </div>

            <div>
              <div className={`FormFullGroup`}>
                <Controller
                  control={control}
                  {...register("phone", { required: "This field is Required", validate: isValidPhoneNumber })}
                  render={({ field }) => (<Input {...field} country={selectCountry} international withCountryCallingCode inputComponent={CustomInput} />)}
                />
                {errors.phone && errors.phone.type !== "validate" && (<span className={`ErrorM`}>{errors.phone.message}</span>)}
                {errors.phone && errors.phone.type === "validate" && (<span className={`ErrorM`}>Please enter valid phone</span>)}
              </div>
            </div>

            <div>
              <div className={`FormFullGroup`}>
                <Controller
                  control={control}
                  {...register("email")}
                  render={({ field }) => (<TextField {...field} label="Email" variant="outlined" />)}
                />
              </div>
            </div>
          </div>

          <div className={`${styles.StepOneFormSmall2} ${styles.StepOneFormSmall254}`}>
            <div className={`FormFullGroup`}>
              <Controller
                control={control}
                {...register("address", { required: "This field is Required" })}
                render={({ field }) => (<TextField {...field} label="Address*" variant="outlined" inputRef={placeRef1} placeholder="" />)}
              />
              {errors?.address && (<p className={`${styles.ErrorM}`}>{errors?.address?.message}</p>)}
            </div>
            <div>
              <MapComponent center={mapCenter} zoom={zoom} isMarker={isMarker} />
            </div>
          </div>

          <div className={`${styles.StepBUSec}`}>
            <button type="button" onClick={backToTab} className={`${styles.Previous}`}>Back</button>
            <button type="submit" className={`${styles.Next}`}>Next</button>
          </div>
        </div>
      </form>
    </div>
  </>);
}

export default Step3;